var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardLoyalty02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 367,
    viewBox: "0 0 375 367",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34217_192077)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 367,
    rx: 12,
    fill: "url(#paint0_radial_34217_192077)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -197,
    width: 375,
    height: 264,
    fill: "#00539F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.676 -9.03615L417.487 -39.5467L278.81 215.466L150 245.977L288.676 -9.03615Z",
    fill: "url(#paint1_linear_34217_192077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.129 -20.7333L487.647 -85.5467L302.517 277.818L159 342.632L344.129 -20.7333Z",
    fill: "url(#paint2_linear_34217_192077)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_34217_192077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(321.427 260.383 -266.059 1250.62 67.2863 146.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00539F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00539F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34217_192077",
    x1: 222.823,
    y1: -86.3806,
    x2: 222.823,
    y2: 206.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34217_192077",
    x1: 283.568,
    y1: -110.42,
    x2: 349.909,
    y2: 266.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34217_192077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 367,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLoyalty02);
export default __webpack_public_path__ + "static/media/Card_Loyalty_02.ea3a92c63df78adc0082093e55233c0d.svg";
export { ForwardRef as ReactComponent };